import type { HTMLAttributes } from 'react';
import clsx from 'clsx';

import { Avatar, AvatarImage } from '../Avatar';
import { Button } from '../Button';

import styles from './styles/Profile.module.scss';

export type ProfileProps = {
  description?: string;
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  image: string;
  layout?: 'column' | 'row';
  name: string;
  profileLink?: {
    href: string;
    text: string;
  };
  size?: 's' | 'm' | 'l';
};

const Profile = ({
  description,
  headingLevel = 'h3',
  image,
  layout = 'column',
  name,
  profileLink,
  size = 'm',
  ...divProps
}: ProfileProps & HTMLAttributes<HTMLDivElement>) => {
  const Heading = headingLevel;
  return (
    <div
      data-cxy-name="profile"
      {...divProps}
      className={clsx(styles.profile, styles[`size-${size}`], styles[`layout-${layout}`], divProps.className)}
    >
      <Avatar className={styles.image}>
        <AvatarImage alt={`Image of ${name}`} src={image} />
      </Avatar>
      <div className={styles.details}>
        <Heading className={styles.name}>{name}</Heading>
        {description && <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />}
        {profileLink && (
          <Button asChild className={styles.link} variant="ghostBrand">
            <a href={profileLink.href}>{profileLink.text}</a>
          </Button>
        )}
      </div>
    </div>
  );
};

export { Profile };
